import { MapToContext } from '@utils/objectWithDefault'

export default class GetStartedStep {
  constructor (getStartedStep) {
    const defaultGetStartedStep = {
      ItemId: {val: null, type: Number},
      DisplayOrder: {val: null, type: Number},
      Href: {val: null, type: String},
      IsLegacyHref: {val: false, type: Boolean},
      IsCompleted: {val: false, type: Boolean}
    }
    MapToContext(this, defaultGetStartedStep, getStartedStep)
  }
}
